"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Languages_1 = require("Core/Languages");
exports.CartShowMoreBtn = function () {
  var PRODUCTS = $('.cart-step2-product');
  var TOGGLER_VIS_BTN = $('#show-more-products-btn');
  PRODUCTS.slice(0, 3).removeClass('product-hide');
  if (PRODUCTS.length <= 3) {
    TOGGLER_VIS_BTN.hide();
  } else {
    TOGGLER_VIS_BTN.click(function () {
      var text;
      if (PRODUCTS.hasClass('product-show')) {
        switch (Languages_1.getCurrentLanguage) {
          case 'pl':
            text = 'Pokaż więcej';
            break;
          case 'ru':
            text = 'Показать больше';
            break;
          default:
            text = 'Show more';
        }
        TOGGLER_VIS_BTN.text(text);
      } else {
        switch (Languages_1.getCurrentLanguage) {
          case 'pl':
            text = 'Pokaż mniej';
            break;
          case 'ru':
            text = 'Показывай меньше';
            break;
          default:
            text = 'Show less';
        }
        TOGGLER_VIS_BTN.text(text);
      }
      PRODUCTS.toggleClass('product-show');
    });
  }
}();